import { z } from 'zod/v4';

import { BID_SIZE_BANDS } from '../shared/bid-size';
import { bidSizeRangesSchema } from '../shared/bid-size-schema';

// The targeted-state report fans the same vendor scoreboard out across a small
// set of states, auto-tuning the "winning filters" per state. The state axis is
// capped so the rendered PDF stays a handful of pages.
export const MAX_REPORT_STATES = 8;

const bidSizeBandIds = BID_SIZE_BANDS.map((b) => b.id) as [string, ...string[]];

// One filter the user has locked for a state, overriding the auto-tuner on that
// axis. `ownerId`/`bidSize` left nullish mean "don't pin this axis".
const pinnedFilterSchema = z.object({
  state: z.string().uuid(),
  ownerId: z.string().uuid().nullish(),
  bidSize: z.enum(bidSizeBandIds).nullish(),
});

export const targetedStateReportQuerySchema = z.object({
  // The client/prospect the report profiles (the global vendor).
  vendorId: z.string().uuid(),
  // The states to fan out across — at least one, capped at MAX_REPORT_STATES.
  states: z.array(z.string().uuid()).min(1).max(MAX_REPORT_STATES),
  // Bounds the auto-tuner's owner axis (omit = consider all owners).
  owners: z.array(z.string().uuid()).optional(),
  // Bounds the auto-tuner's bid-size axis (omit = consider all sizes).
  bidSizes: bidSizeRangesSchema,
  startDate: z.coerce.date().optional(),
  endDate: z.coerce.date().optional(),
  // Per-state overrides the auto-tuner must honor instead of tuning that axis.
  pinnedFilters: z.array(pinnedFilterSchema).optional(),
});

export type TargetedStateReportQuery = z.infer<
  typeof targetedStateReportQuerySchema
>;
